import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Facility from "./components/Facility.js";
import Footer from "./components/Footer.js";
import Navbar from "./components/Navbar.js";
import Home from "./components/Home.jsx";
import VisionMission from './components/VisionMission';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={
        <>
          <Navbar />
          <Home/>
          <VisionMission />
          <Footer/>
        </>
      } />
      <Route path="/facility" element={
        <>
          <Navbar />
          <Facility/>
          <Footer/>
        </>
      } />
    </Routes>
  );
};

export default App;